import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
  selector: 'lib-canvas-home',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './canvas-home.component.html',
  styleUrl: './canvas-home.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CanvasHomeComponent {}
